import pdf from '../../../assets/images/fileImage/pdf.png';
import image from '../../../assets/images/fileImage/image_icon.png';
import ppt from '../../../assets/images/fileImage/ppt.png';
import docs from '../../../assets/images/fileImage/docs.png'
import excel from '../../../assets/images/fileImage/excel.png'

export const getFileImagePath = (doc_path: string): string => {
    const extension = doc_path.split('.').pop()?.toLowerCase() || '';
    switch (extension) {
        case 'pdf':
            return pdf;
        case 'png':
        case 'jpeg':
        case 'jpg':
            return image;
        case 'doc':
        case 'docx':
            return docs;
        case 'xls':
        case 'xlsm':
        case 'xlsx':
            return excel;
        case 'ppt':
        case 'pptx':
            return ppt;

        default:
            return ''; // Or a default image if needed
    }
};